import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEyeOff = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1.125em",
	height: "1.125em",
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_3569_332)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M7.15534 3.38404C8.70827 3.19898 10.2791 3.52725 11.6279 4.31874C12.9768 5.11023 14.0295 6.32142 14.6253 7.76737C14.6809 7.91705 14.6809 8.0817 14.6253 8.23137C14.3803 8.82537 14.0566 9.38371 13.6627 9.89137M9.38934 9.43871C9.01214 9.80302 8.50694 10.0046 7.98254 10.0001C7.45815 9.9955 6.95652 9.78516 6.58571 9.41434C6.21489 9.04353 6.00455 8.5419 6 8.01751C5.99544 7.49312 6.19703 6.98791 6.56134 6.61071M11.6527 11.666C10.7683 12.1899 9.78165 12.5174 8.75959 12.6263C7.73752 12.7352 6.70398 12.623 5.7291 12.2973C4.75422 11.9716 3.86081 11.44 3.10949 10.7385C2.35816 10.0371 1.76651 9.18228 1.37468 8.23204C1.31912 8.08236 1.31912 7.91772 1.37468 7.76804C1.96577 6.33461 3.00579 5.13154 4.33868 4.33937M1.33334 1.33337L14.6667 14.6667",
			stroke: "#292929",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3569_332",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgEyeOff;
